type ViteEnvRecord = Record<string, string | boolean | undefined>;

export interface SupabaseRuntimeCredentials {
  supabaseUrl: string | undefined;
  supabaseAnonKey: string | undefined;
  runtimeEnv: Record<string, string> | undefined;
}

export function getBrowserRuntimeEnv(): Record<string, string> | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }
  return (window as { __ENV__?: Record<string, string> }).__ENV__;
}

/**
 * Resolve Supabase Runtime Credentials.
 */
export function resolveSupabaseRuntimeCredentials(
  viteEnv: ViteEnvRecord,
  maxWaitMs = 500
): SupabaseRuntimeCredentials {
  let runtimeEnv = getBrowserRuntimeEnv();
  let supabaseUrl =
    runtimeEnv?.VITE_SUPABASE_URL || (viteEnv.VITE_SUPABASE_URL as string | undefined);
  let supabaseAnonKey =
    runtimeEnv?.VITE_SUPABASE_ANON_KEY || (viteEnv.VITE_SUPABASE_ANON_KEY as string | undefined);

  if (supabaseUrl && supabaseAnonKey) {
    return { supabaseUrl, supabaseAnonKey, runtimeEnv };
  }

  const start = Date.now();
  while ((!supabaseUrl || !supabaseAnonKey) && Date.now() - start < maxWaitMs) {
    const checkStart = Date.now();
    while (Date.now() - checkStart < 10) {
      // Busy wait 10ms for config.js
    }
    runtimeEnv = getBrowserRuntimeEnv();
    supabaseUrl =
      runtimeEnv?.VITE_SUPABASE_URL || (viteEnv.VITE_SUPABASE_URL as string | undefined);
    supabaseAnonKey =
      runtimeEnv?.VITE_SUPABASE_ANON_KEY || (viteEnv.VITE_SUPABASE_ANON_KEY as string | undefined);
  }

  return { supabaseUrl, supabaseAnonKey, runtimeEnv };
}

export function validateSupabaseUrl(supabaseUrl: string): void {
  if (!supabaseUrl.startsWith("https://")) {
    throw new Error(`Invalid VITE_SUPABASE_URL: "${supabaseUrl}". Must start with https://`);
  }
}

export function validateApiUrl(apiUrl: string): void {
  if (!apiUrl.startsWith("http://") && !apiUrl.startsWith("https://")) {
    throw new Error(`Invalid VITE_API_URL: "${apiUrl}". Must start with http:// or https://`);
  }
}

export function requireNonEmptyEnv(value: string | undefined, name: string): string {
  if (!value) {
    throw new Error(
      `${name} is required but not set. Please check your .env file or environment configuration.`
    );
  }
  return value;
}
